angular.module('lf.desktop')

.factory('videoPlayerService', function ($sce, popupsService, gtmService) {
  
  return {
    init: function (scope, data) {

      data.video = {

        relatedProdId: null,
        originalVideoURL: null,
        ready: false,
        playing: false,
        error: false,
        
        toggle: function () {
          this.playing ? this.pause() : this.play();
        },
        
        play: function () {
          scope.$broadcast('video:play');
          this.playing = true;

          data.video.broadcastGTMEvent('Play');
        },
        
        pause: function () {
          scope.$broadcast('video:pause');
          this.playing = false;

          data.video.broadcastGTMEvent('Pause');
        },
        
        rewind: function () {
          scope.$broadcast('video:rewind');

          data.video.broadcastGTMEvent('Rewind');
        },

        broadcastGTMEvent: function (action) {
          gtmService.pushVideoActivity({'action': action, url: data.video.originalVideoURL, prodId: data.video.relatedProdId});
        }
      }
        
      scope.showVideoPopup = function (videoUrl, productId) {
        data.video.relatedProdId = productId;
        data.video.originalVideoURL = videoUrl;
        data.video.url = $sce.trustAsResourceUrl(videoUrl);
        popupsService.show('video-popup');

        data.video.broadcastGTMEvent('Play');
      }
      
      scope.hideVideoPopup = function () {
    	  popupsService.hide('video-popup');
        $.extend(data.video, {
          url: null,
          ready: false,
          playing: false,
          error: false
        });
      }

      scope.$on('video:ready', function () {
        data.video.ready = true;
        data.video.error = false;
      });
      
      scope.$on('video:playing', function (e, playing) {
        data.video.playing = playing;
      });
      
      scope.$on('video:error', function (e, error) {
        data.video.error = true;
      });
    }
  }
});
